import { useState } from "react";

const SearchInput2 = ({
  id = "text-input",
  name = "text-name",
  type = "text",
  autoComplete = "text",
  required = false,
  className = "",
  value,
  placeholder = "Type here",
  disabled = false,
  defaultValue = undefined,
  onChange,
  onKeyDown = undefined,
  onBlur = undefined,
  onInput = undefined,
  onKeyPress = undefined,
  maxLength = undefined,
  step = undefined,
  min = undefined,
  max = undefined,
  label = undefined,
  preIcon: Component = undefined,
  readOnly = false,
  inputTextHeight = "h-7",
  width = "w-full",
  pattern = undefined,
  onSelectionChange,
}) => {
  const [focus, setFocus] = useState(false);
  return (
    <div className="space-y-1 w-full">
      {label && (
        <label htmlFor={id} className="text-sm">
          {label}
        </label>
      )}
      <div className="relative flex items-center w-full">
        {Component && (
          <Component
            className={`h-5 w-5 absolute z-20 ml-2 ${
              focus ? "text-blue-400" : "text-gray-400"
            }`}
          />
        )}
        <input
          id={id}
          type={type}
          name={name}
          defaultValue={defaultValue}
          value={value}
          autoComplete={autoComplete}
          required={required}
          disabled={disabled}
          readOnly={readOnly}
          className={`border-b ${inputTextHeight} ${width}  text-login bg-white bg-clip-padding  leading-normal 
          outline-none focus:ring-septenary focus:border-septenary block px-1 py-1 text-xs sm:text-xs border-b-2 border-gray-300 
          rounded-sm ${className} ${Component && "pl-10"} ${
            disabled && "opacity-50"
          }`}
          onFocus={() => {
            setFocus(true);
          }}
          onBlur={onBlur ? onBlur : () => setFocus(false)}
          onChange={onChange}
          onKeyDown={onKeyDown}
          onKeyPress={onKeyPress}
          onInput={onInput}
          placeholder={placeholder}
          maxLength={maxLength}
          step={step}
          min={min}
          max={max}
          pattern={pattern}
          onSelectionChange={(rows) => {
            onSelectionChange(
              rows.map((r) => {
                const { tableData, ...rows } = r;
                return rows;
              })
            );
          }}
        />
      </div>
    </div>
  );
};
export default SearchInput2;
